import classNames from "classnames";
import React, { useState } from "react";

import Tooltip, { TooltipProps } from "../Tooltip";
import { CopyButton, CopyContainer, TruncateText } from "./Copy.styled";

import iconCopyV2 from "src/assets/images/icons/copy-v2.png";
import iconCopy from "src/assets/images/icons/copy.png";

import { getTranslationManually } from "src/helpers/locale";
import { copyText } from "src/helpers/string";
import { ButtonProps } from "../Button";

export type CopyProps = ButtonProps & {
  /**
   * Set text to be copied
   */
  textCopy?: string | number;

  /**
   * Set button to show only the icon
   */
  iconOnly?: boolean;

  /**
   * Override default icon type
   *
   * * @type {"outline" | "fill" }
   */
  iconType?: "outline" | "fill";

  /**
   * Override default tooltip position
   */
  tooltipPosition?: TooltipProps["position"];

  /**
   * text will truncate
   */
  isTruncate?: boolean;
};

const defaultProps = {
  textCopy: "",
  iconOnly: false,
  iconType: "outline",
  tooltipPosition: "top",
  isTruncate: false
};

const CopyComp = React.forwardRef<HTMLDivElement, CopyProps>((props, ref) => {
  const { className, textCopy, iconOnly, tooltipPosition, iconType, isTruncate, ...restProps } = props;
  const copyClass = classNames("c-copy", iconOnly && "c-copy--icon-only", className);
  const [showTooltip, setShowTooltip] = useState(false);

  function handleCopyText() {
    copyText(textCopy);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1000);
  }

  return (
    <CopyContainer data-testid="qa-copy" ref={ref} className={copyClass}>
      <Tooltip.Wrapper>
        <CopyButton data-testid="qa-copy-button" onClick={handleCopyText} variant="tertiary" {...restProps}>
          <div className="u-inline-flex u-items-center">
            <img
              data-testid="qa-copy-button-image"
              src={iconType === "outline" ? iconCopyV2 : iconCopy}
              alt="copy"
              className={classNames(!iconOnly && "u-mr-2")}
              height={iconType === "outline" ? "18" : "15"}
            />
            {!iconOnly && getTranslationManually("Salin", "Copy")}
          </div>
        </CopyButton>
        {showTooltip && (
          <Tooltip data-testid="qa-copy-tooltip-copied" position={tooltipPosition}>
            {isTruncate ? <TruncateText data-testid="qa-copy-text-copy">{textCopy}</TruncateText> : textCopy}
            {getTranslationManually(" disalin", " copied")}!
          </Tooltip>
        )}
        <Tooltip data-testid="qa-copy-tooltip" className="c-copy__tooltip-info" position={tooltipPosition}>
          {getTranslationManually("Salin ", "Copy ")}{" "}
          {isTruncate ? <TruncateText data-testid="qa-copy-text-copied">{textCopy}</TruncateText> : textCopy}
        </Tooltip>
      </Tooltip.Wrapper>
    </CopyContainer>
  );
});

const Copy = Object.assign(CopyComp, { defaultProps });

export default Copy;
